import {ErrorMessage} from 'formik';
import {useTranslation} from 'react-i18next';

import {Grid, Typography} from '@mui/material';

import {EmpionMultiSelect} from '../../../../../../../../../components/EmpionMultiSelect/EmpionMultiSelect';
import {CompanyLocation} from '../../../../../types/JobPostingsTypes';

interface HardFactsFieldsLocationsProps {
  formik: any;
  options: CompanyLocation[];
  displayDefaultLocations: boolean;
}

export const HardFactsFieldsLocations = ({formik, options, displayDefaultLocations}: HardFactsFieldsLocationsProps) => {
  const {t} = useTranslation();

  const locationOptions = options.map((option) => {
    return {
      id: option.resourceId,
      label: option.city as string,
    };
  });

  const addRemoteOption = () => {
    const remoteHiringOption = [
      {
        id: 'remote',
        label: 'Remote',
      },
    ];

    return [...locationOptions, ...remoteHiringOption];
  };

  const handleSelection = (selectedLocations: any) => {
    const remoteSelected = selectedLocations.includes('remote');
    const filteredLocations = selectedLocations.filter((location: string) => {
      return location !== 'remote';
    });
    formik.setFieldValue('locations', filteredLocations);
    formik.setFieldValue('remoteHiring', remoteSelected);
  };

  const getDefaultLocations = () => {
    if (!displayDefaultLocations) {
      return;
    }
    const result = addRemoteOption()
      .map((option) => {
        if (formik.values.locations.includes(option.id) || (option.id === 'remote' && formik.values.remoteHiring)) {
          return option?.label;
        }
      })
      .filter((option) => option !== undefined);
    return result;
  };

  return (
    <Grid item xs={12}>
      <EmpionMultiSelect
        size='small'
        label={`${t('companyJobPostings.newJobDialog.formLabels.locations')}*`}
        options={addRemoteOption()}
        onChange={handleSelection}
        displayDefaultOptions={getDefaultLocations()}
      />
      <Typography variant='body2' color='error'>
        <ErrorMessage name='locations' component='span' />
      </Typography>
    </Grid>
  );
};
